// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3M9CQ","savePackageButton":"ClientWallet_savePackageButton__brg4F"};